import { darkTheme } from "@remar/shared/dist/theme/customThemes";

export default darkTheme;
